<template>
  <div class="form-layout" :class="[`form-layout-col-${cols}`]">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  const props = defineProps({
    cols: {
      type: Number,
      default: 4,
    },
    width: {
      type: String,
      default: '',
    },
  });

  const colsWidth = computed(() => {
    if (props.width) return props.width;
    if (props.cols === 3) return '500px';
    return '350px';
  });
</script>

<style scoped lang="less">
  .form-layout {
    :deep(.arco-form-item) {
      width: 45%;
    }

    // 3列布局
    &.form-layout-col-3 {
      :deep(.arco-form-item) {
        max-width: v-bind(colsWidth);
      }
    }

    // 4列布局
    &.form-layout-col-4 {
      :deep(.arco-form-item) {
        max-width: v-bind(colsWidth);
      }
    }

    // 处理全宽的 form-item（通过 row-class="wp100" 等）
    :deep(.arco-form-item) {
      &[class*='wp100'],
      &[class*='full-width'] {
        max-width: 100%;
        width: 100%;
      }
    }
  }
</style>
